import React from "react";

/**
 * Casca DOM de um slot com controlador de plugin.
 *
 * Duas camadas irmãs: `originalRef` embrulha o conteúdo nativo do app (é ele que
 * o plugin esconde com `slot.hide()`), e `layerRef` recebe o que o plugin injeta
 * com `add()`/`mount()`/`mountJsx()`. Só existe quando há controlador — sem
 * plugin registrado, o Bridge devolve os children direto, sem nenhuma `div`.
 *
 * ## `layout`
 *
 * Antes esta casca era sempre `flex; flex:1; width:100%`, escolhido para os três
 * pontos que usavam o wrap. Montada agora em qualquer slot, essa escolha fixa
 * deformaria pontos que não pediram nada — um badge de item de lista, um item de
 * menu. Daí a prop:
 *
 *   contents — o wrapper externo não participa do layout (`display: contents`);
 *              os filhos se comportam como se ele não existisse. É o padrão, e o
 *              único seguro para um componente montado em toda parte.
 *   flex     — comportamento histórico do PluginWrap. Necessário onde a
 *              centralização vinha justamente deste wrapper: as duas colunas de
 *              `<TableCell>` em Conexões.
 *   block    — `div` comum, para quando nem um nem outro serve.
 *
 * As camadas internas continuam sendo `div` de verdade mesmo em `contents`:
 * `hide()` funciona escrevendo `style.display` no nó de `originalRef`, então ele
 * precisa existir como elemento.
 */
export default function PluginSlotWrap({ layout = "contents", originalRef, layerRef, children }) {
  const estiloExterno =
    layout === "flex"
      ? { display: "flex", flex: 1, alignItems: "center", width: "100%" }
      : layout === "block"
        ? undefined
        : { display: "contents" };

  const estiloOriginal =
    layout === "flex"
      ? { display: "flex", flex: 1, width: "100%" }
      : { display: "contents" };

  return (
    <div style={estiloExterno}>
      <div ref={originalRef} style={estiloOriginal}>
        {children}
      </div>
      <div ref={layerRef} style={{ display: "contents" }} />
    </div>
  );
}
